import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import { fetchAuthUsers } from 'src/redux/authUsers/authUser.action';
import { getCurrentAuthUser, getAuthUsers } from 'src/redux/authUsers/authUser.selector';
import { fetchAuthOrganizations } from 'src/redux/authOrganizations/authOrganization.action';
import { getAuthOrganizations } from 'src/redux/authOrganizations/authOrganization.selector';

import Logout from 'src/ConnectedComponents/Logout';
import Logo from 'src/ConnectedComponents/utils/Logo';
import AnimatedLogo from 'src/ConnectedComponents/utils/AnimatedLogo';
import TermsOfUse from './TermsOfUse';
import ConnectCRM from './ConnectCRM';
import StartSync from './StartSync';
import Syncing from './Syncing';
import SyncError from './SyncError';
import UserSetup from './UserSetup';
import Waitlist from './Waitlist';
import Intermission from './Intermission';

import style from './index.css';
import { FlexBox } from 'src/lib/StyledComponents';

const showFacadeableComponent = (ComponentName, props, showFacade) => {
	return showFacade ? (
		<Redirect to="/setup/waitlist" />
	) : (
		<ComponentName
			{...props}
			currentAuthUser={props.currentAuthUser}
			authOrganizations={props.authOrganizations}
		/>
	);
};

class Setup extends Component {
	componentDidMount() {
		this.props.fetchAuthUsers();
		this.props.fetchAuthOrganizations();
	}

	render() {
		// wait for authOrganizations result
		if (
			!this.props.authUsers.length ||
			!this.props.authOrganizations.length ||
			!this.props.authOrganizations[0].setup_state
		) {
			return null;
		}

		const currentAuthUser = this.props.currentAuthUser;
		const authOrganizations = this.props.authOrganizations;
		const showFacade =
			authOrganizations[0].show_facade && !window.localStorage.hasOwnProperty('login_as');

		return (
			<FlexBox className={style.SetupContent} flexDirection="column">
				{showFacade && window.location.pathname === '/setup/waitlist' ? (
					<AnimatedLogo style={{ width: '160px' }} />
				) : (
					<Logo />
				)}
				<Logout />
				<Switch>
					<Route
						path="/setup/terms"
						render={props => (
							<TermsOfUse
								{...props}
								currentAuthUser={currentAuthUser}
								authOrganizations={authOrganizations}
							/>
						)}
					/>
					<Route
						path="/setup/connect_crm"
						render={props => (
							<ConnectCRM
								{...props}
								currentAuthUser={currentAuthUser}
								authOrganizations={authOrganizations}
							/>
						)}
					/>
					<Route
						path="/setup/processing"
						render={props => (
							<StartSync
								{...props}
								currentAuthUser={currentAuthUser}
								authOrganizations={authOrganizations}
							/>
						)}
					/>
					<Route path="/setup/waitlist" render={_ => <Waitlist />} />
					<Route
						path="/setup/syncing"
						render={props =>
							showFacadeableComponent(
								Syncing,
								{ ...props, currentAuthUser, authOrganizations },
								showFacade,
							)
						}
					/>
					<Route
						path="/setup/sync_error"
						render={props =>
							showFacadeableComponent(
								SyncError,
								{ ...props, currentAuthUser, authOrganizations },
								showFacade,
							)
						}
					/>
					<Route
						path="/setup/user"
						render={props =>
							showFacadeableComponent(
								UserSetup,
								{ ...props, currentAuthUser, authOrganizations },
								showFacade,
							)
						}
					/>
					<Route
						path="/setup/intermission"
						render={() => <Intermission authOrganizations={authOrganizations} />}
					/>
				</Switch>
			</FlexBox>
		);
	}
}

const mapStateToProps = state => ({
	currentAuthUser: getCurrentAuthUser(state),
	authOrganizations: getAuthOrganizations(state),
	authUsers: getAuthUsers(state),
});

const actions = {
	fetchAuthUsers,
	fetchAuthOrganizations,
};

Setup = connect(mapStateToProps, actions)(Setup);

export default Setup;



// WEBPACK FOOTER //
// ./src/ConnectedComponents/Setup/index.js